const bodyFocusConstants = {
  width: 555,
  height: 1280,
};

export default bodyFocusConstants;
